import { useLingui } from "@lingui/react/macro";
import { Button, Input } from "@rakazo/ui-web";
import { ArrowLeft, SlidersHorizontal } from "lucide-react";
import { useId, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWorkspaceDesktop } from "../components/WorkspaceSession";
import { emptyActivityFilters } from "../lib/activity-list-filters";
import { ActivityList } from "./ActivityList";

export function TasksPage() {
  const { t } = useLingui();
  const navigate = useNavigate();
  const desktop = useWorkspaceDesktop();
  const [filters, setFilters] = useState(emptyActivityFilters);
  const [expanded, setExpanded] = useState(false);
  const filtersId = useId();
  return (
    <main className="tasks-app flex h-full min-h-0 flex-col bg-background" data-testid="tasks-page">
      <header className="app-toolbar flex shrink-0 items-center gap-3 px-5 py-3">
        {!desktop && (
          <>
            <Button
              variant="ghost"
              size="icon-sm"
              aria-label={t`Home`}
              onClick={() => navigate("/app")}
            >
              <ArrowLeft size={16} />
            </Button>
            <h1 className="text-sm font-medium">{t`Tasks`}</h1>
          </>
        )}
        <Input
          aria-label={t`Search tasks`}
          placeholder={t`Search tasks`}
          value={filters.query}
          onChange={(event) => setFilters({ ...filters, query: event.target.value })}
          onKeyDown={(event) => {
            if (event.key === "Escape") setFilters({ ...filters, query: "" });
          }}
          className="min-w-0 flex-1 border-transparent bg-muted/50"
        />
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={t`Filters`}
          aria-expanded={expanded}
          aria-controls={filtersId}
          onClick={() => setExpanded(!expanded)}
        >
          <SlidersHorizontal size={16} />
        </Button>
      </header>
      <div className="rk-scroll min-h-0 flex-1 overflow-y-auto px-4 py-2">
        <ActivityList
          filters={filters}
          onFiltersChange={setFilters}
          filtersExpanded={expanded}
          filtersId={filtersId}
          onOpenRun={(run) => {
            const jump = run.task?.messageId ? `?m=${encodeURIComponent(run.task.messageId)}` : "";
            navigate(run.groupId ? `/app/g/${run.groupId}${jump}` : `/app/${run.botId}${jump}`);
          }}
        />
      </div>
    </main>
  );
}
